// Module
var code = "<script id=\"wcc-components-tag-picker\" type=\"text/html\">\r\n    <!-- ko foreach: items -->\r\n    <tag params=\"tag: tag, hideRoot: $component.isRootHidden\" data-bind=\"click: $component.toggle, css: { 'wcc-tag--disabled': !isSelected() }\"></tag>\r\n    <!-- /ko -->\r\n</script>";
// Exports
module.exports = code;